import type {
  EmailCompositionValue,
  EmailFieldErrors,
} from '@kula-ai/components';
import { isHtmlEffectivelyEmpty } from '@kula-ai/components';

const SUBJECT_MAX_LENGTH = 150;

export function validateSlotSelectionEmail(
  value: EmailCompositionValue,
  from: string
): EmailFieldErrors | undefined {
  const errors: EmailFieldErrors = {};

  if (!from?.trim()) {
    errors.from = 'From is required';
  }

  const subject = value.subject?.trim() ?? '';
  if (!subject) {
    errors.subject = 'Subject is required';
  } else if (subject.length > SUBJECT_MAX_LENGTH) {
    errors.subject = `Subject must be at most ${SUBJECT_MAX_LENGTH} characters`;
  }

  if (isHtmlEffectivelyEmpty(value.content)) {
    errors.content = 'Body is required';
  }

  return Object.keys(errors).length ? errors : undefined;
}
